import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-09fcc5a6"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "main"
};

const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"info-main\" data-v-09fcc5a6><p class=\"info-title\" data-v-09fcc5a6>使用目的</p><div class=\"info-desc\" data-v-09fcc5a6>实名认证、支付宝提现</div></div><div class=\"info-main\" data-v-09fcc5a6><p class=\"info-title\" data-v-09fcc5a6>使用场景</p><div class=\"info-desc\" data-v-09fcc5a6>完成实名认证时填写姓名；<br data-v-09fcc5a6> 支付宝提现时填写姓名；</div></div><div class=\"info-main\" data-v-09fcc5a6><p class=\"info-title\" data-v-09fcc5a6>收集主体</p><div class=\"info-desc\" data-v-09fcc5a6>本APP</div></div>", 3);

const _hoisted_5 = {
  class: "info-main"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "info-title"
}, "收集情况", -1));

const _hoisted_7 = {
  class: "info-desc"
};

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info-main"
}, [/*#__PURE__*/_createElementVNode("p", {
  class: "info-title"
}, "信息内容"), /*#__PURE__*/_createElementVNode("div", {
  class: "info-desc"
})], -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_top_title = _resolveComponent("top-title");

  const _component_time_select = _resolveComponent("time-select");

  const _component_bottom_tip = _resolveComponent("bottom-tip");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", null, [_createVNode(_component_top_title, {
    onBack: $setup.back,
    title: "电信运营商"
  }, null, 8, ["onBack"]), _createVNode(_component_time_select, {
    onChangeVal: $setup.change
  }, null, 8, ["onChangeVal"]), _hoisted_2, _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, "已收集" + _toDisplayString($setup.info.count) + "次", 1)]), _hoisted_8]), _createVNode(_component_bottom_tip)]);
}